import { render, staticRenderFns } from "./VDesigningIframePointer.vue?vue&type=template&id=820718ac&"
import script from "./VDesigningIframePointer.vue?vue&type=script&lang=ts&"
export * from "./VDesigningIframePointer.vue?vue&type=script&lang=ts&"
import style0 from "./VDesigningIframePointer.vue?vue&type=style&index=0&id=820718ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports